import classNames from 'classnames'

interface Props {
  active: string
  items: Array<{ name: string; id: string; isLink?: boolean }>
  onChange: (p: { name: string; id: string; isLink?: boolean }) => void
  className?: string
  hiddenUnderline?: boolean
}

export default function MyTabs({
  items,
  active,
  onChange,
  className,
  hiddenUnderline,
}: Props) {
  return (
    <div className={classNames('flex items-center font-semibold', className)}>
      {items.map(item => {
        return (
          <div
            key={item.id}
            className={classNames(
              'mr-4 cursor-pointer relative pb-1.5 transition-all hover:text-neutral-800 myTabsItem',
              {
                'myTabsActive text-neutral-800': active === item.id,
              }
            )}
            onClick={() => {
              onChange(item)
            }}
          >
            {item.name}
            <div
              className={classNames(
                'absolute bottom-0 left-0 right-0 bg-primary transition-all active-bar',
                { 'h-1': active === item.id, '!h-0': hiddenUnderline }
              )}
            ></div>
          </div>
        )
      })}
    </div>
  )
}
